import type { ReactNode } from 'react';
import { cn } from '@/shared/helpers/cn';
import styles from './EmptyState.module.scss';

export interface EmptyStateProps {
  /** Titulo curto. */
  title: string;
  /** Uma linha explicando. */
  description?: string;
  /** Icone dentro do circulo tonal. Decorativo. */
  icon?: ReactNode;
  /** Acao primaria. Tela vazia e convite para agir. */
  action?: ReactNode;
  className?: string;
}

/**
 * Estado vazio.
 *
 * "Sem dados" nunca e uma tela em branco: a mensagem diz o que fazer, e o botao
 * primario permite fazer sem sair dali.
 */
export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div className={cn(styles.root, className)}>
      {icon ? (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <p className={styles.title}>{title}</p>
      {description ? <p className={styles.description}>{description}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
